import { render } from "./BlFlowForm.vue?vue&type=template&id=cd09413e&scoped=true"
import script from "./BlFlowForm.vue?vue&type=script&lang=js"
export * from "./BlFlowForm.vue?vue&type=script&lang=js"

import "./BlFlowForm.vue?vue&type=style&index=0&id=cd09413e&scoped=true&lang=scss"

import exportComponent from "/tmp/b7562a83-daa0-4796-bff7-c3f4922e39c8/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd09413e"]])

export default __exports__